import { useEffect } from 'react'
import useAmplitude from '@eversports/amplitude-react/useAmplitude'
import AmplitudeIdentify from '@eversports/amplitude-react/amplitude-identify'

import { UserFeaturePreviews } from './user-feature-previews'

const useTrackExperiments = (
  experimentsToTrack: Array<UserFeaturePreviews>,
  enabledExperiments: Array<UserFeaturePreviews> | undefined,
) => {
  const { amplitude } = useAmplitude()

  useEffect(() => {
    if (!enabledExperiments) return
    const experimentsMapping = experimentsToTrack.map((experiment) => {
      return {
        name: experiment,
        isEnabled: enabledExperiments?.includes(experiment),
      }
    })

    if (!amplitude || experimentsMapping.length === 0) return

    const identify = new AmplitudeIdentify()

    // For every active experiment track if the user is seeing the new version
    for (const experiment of experimentsMapping) {
      identify.set(`[A/B TEST] ${experiment.name}`, Boolean(experiment.isEnabled))
    }

    amplitude.identify(identify)
  }, [amplitude, enabledExperiments])
}

export default useTrackExperiments
